function handleError(error) {
  let message = "";

  if(error.response && error.response.data) {
    if(typeof error.response.data === "string") {
      message = error.response.data
    }

    if(typeof error.response.data === "object") {
      // seems the same but hope to find patterns and nmake robust enough
      if(error.response.data.message) {
        message = error.response.data.message
      } else {
        message = JSON.stringify(error.response.data)
      }
    }
  } else if(error.request) {
    message = error.message
  } else {
    message = error.message || "Internet Unavailable"
  }

  return message
}

export default handleError